import { gql } from '@apollo/client'

export const UPDATE_ROOM_VIEW_PATIENT_STATUS = gql`
  mutation UpdatePatientStatus(
    $procedureId: String!
    $patientStatus: String!
    $roomId: Float
  ) {
    updatePatientStatus(
      procedureId: $procedureId
      patientStatus: $patientStatus
      roomId: $roomId
    ) {
      message
    }
  }
`

export const ADD_REMOVE_SURGERY_STAFF = gql`
  mutation AddRemoveSurgeryStaff($input: AddRemoveSurgeryStaffInput!) {
    addRemoveSurgeryStaff(input: $input) {
      success
    }
  }
`

export const UPDATE_APP_CONFIG = gql`
  mutation UpdateAppConfig($input: UpdateAppConfigInput!) {
    updateAppConfig(input: $input) {
      success
    }
  }
`
